import { createReducer, updateItemInArray, updateObject } from 'helpers/ReducerUtil'
import {
  UPDATE_VALUE,
  REMOVE_VALUE,
  ADD_VALUE,
} from './constants'

const addValue = (values, action) => [...values, { vendor: '', part_number: '', count: '', details: '' }]

const removeValue = (values, { index }) => values.filter(
  (value, currentIndex) => index !== currentIndex
)

const updateValue = (values, { value, index, inputType }) => updateItemInArray(
  values,
  index,
  oldValue => updateObject(oldValue, { ...oldValue, [inputType]: value })
)

const pcieSwitchRetimerReducer = createReducer([], {
  [ADD_VALUE]: addValue,
  [REMOVE_VALUE]: removeValue,
  [UPDATE_VALUE]: updateValue
})

export default pcieSwitchRetimerReducer
